import React, { useMemo } from 'react'
import { StyledTablePreviewFullReport } from '../../../styled-components/Table'
import { ColumnsType } from 'antd/es/table'
import { StyledTypographyText } from '../../../styled-components/Typography'
// import { toJS } from 'mobx'

// import styled from 'styled-components'
// export enum fontWeight {
//     Light = 'Light',
//     Regular = 'Regular',
//     Medium = 'Medium',
//     SemiBold = 'SemiBold',
//     Bold = 'Bold',
//     ExtraBold = 'ExtraBold',
// }

// const TableSummaryRow = styled.tr({})
// const TableSummaryCell = styled.td({ textAlign: 'center' })

type TableDataSource = {
    id: string | number
    name: string
    scoreFull: number
    scoreUser: number
    scoreAdmin: number
    // gradeAdmin: string | null
    // gradeUser: string | null
    descriptionAdmin: string | null | undefined
    descriptionUser: string | null | undefined
    [key: string]: any
}

type ReturnTypeUseOverviewTableQuestionnaireFullReport = ReturnType<typeof useOverviewTableQuestionnaireFullReport>
export type UseOverviewTableQuestionnaireFullReport = {
    prefixLabel: string
    titleCell: string
    dataSource: TableDataSource[]
}
const useOverviewTableQuestionnaireFullReport = ({
    prefixLabel,
    titleCell,
    dataSource,
}: UseOverviewTableQuestionnaireFullReport) => {
    const columns: ColumnsType<TableDataSource> = [
        {
            title: <div style={{ textAlign: 'center' }}> {titleCell} </div>,
            dataIndex: 'name',
            key: 'name',
            width: 200,
            align: 'left',
            render: (value: string, rows: TableDataSource, index: number) => {
                return index === dataSource.length ? (
                    <div style={{ textAlign: 'center' }}> {value} </div>
                ) : (
                    <>
                        {prefixLabel}
                        {index + 1}
                        <br />
                        <StyledTypographyText
                            styled={{
                                color: '#000000',
                                fontSize: 20,
                                fontFamily: 'THSarabunNew',
                            }}
                        >
                            {value}
                        </StyledTypographyText>
                    </>
                    //`${prefixLabel}${index + 1} ${value}`
                )
                // return (

                //     // <StyledTypographyText
                //     //     styled={{
                //     //         fontFamily: 'THSarabunNew',
                //     //         fontSize: 20,
                //     //     }}
                //     // >
                //     //     {`${prefixLabel}${index + 1} ${value}`}{' '}
                //     // </StyledTypographyText>
                // )
            },
        },
        {
            title: 'คะแนนเต็ม',
            dataIndex: 'scoreFull',
            key: 'scoreFull',
            width: 100,
            align: 'center',
        },
        {
            title: 'คะแนนโดยชุมชน',
            align: 'center',
            children: [
                {
                    title: 'คะแนนที่ได้',
                    dataIndex: 'scoreUser',
                    key: 'scoreUser',
                    width: 150,
                    align: 'center',
                    render: (value: number | null) => {
                        return (
                            <StyledTypographyText>
                                {typeof value === 'number' ? value.toFixed(2) : '-'}
                            </StyledTypographyText>
                        )
                    },
                },
                {
                    title: 'ระดับคะแนน',
                    dataIndex: 'descriptionUser',
                    key: 'descriptionUser',
                    width: 150,
                    align: 'center',
                    render: (value: number | null) => {
                        return <StyledTypographyText>{value ?? '-'}</StyledTypographyText>
                    },
                },
            ],
        },
        {
            title: 'คะแนนโดยเจ้าหน้าที่',
            children: [
                {
                    title: 'คะแนนที่ได้',
                    dataIndex: 'scoreAdmin',
                    key: 'scoreAdmin',
                    width: 150,
                    align: 'center',
                    render: (value: number | null) => {
                        return (
                            <StyledTypographyText>
                                {typeof value === 'number' ? value.toFixed(2) : '-'}
                            </StyledTypographyText>
                        )
                    },
                },
                {
                    title: 'ระดับคะแนน',
                    dataIndex: 'descriptionAdmin',
                    key: 'descriptionAdmin',
                    width: 150,
                    align: 'center',
                    render: (value: number | null) => {
                        return <StyledTypographyText>{value ?? '-'}</StyledTypographyText>
                    },
                },
            ],
        },
    ]

    const newDataSource = useMemo(() => {
        const isScoreAdminUndefined = dataSource.every((item) => typeof item.scoreAdmin === 'undefined')
        const isScoreUserUndefined = dataSource.every((item) => typeof item.scoreUser === 'undefined')

        const isScoreAdminNull = dataSource.every((item) => item.scoreAdmin === null)
        const isScoreUserNull = dataSource.every((item) => item.scoreUser === null)

        let totalScoreFull = 0
        let isNumberScoreFull = true
        const arrayTotalScoreFull = dataSource.map((item) => item.scoreFull).filter((item) => typeof item === 'number')
        if (arrayTotalScoreFull.length > 0) {
            totalScoreFull = arrayTotalScoreFull.reduce((acc, crr) => {
                return (acc as number) + (crr as number)
            })
        } else {
            isNumberScoreFull = false
        }

        let totalScoreUser = 0
        let totalScoreAdmin = 0
        const arrayScoreUser = dataSource.map((item) => item.scoreUser).filter((item) => typeof item === 'number')
        if (arrayScoreUser.length > 0) {
            totalScoreUser = arrayScoreUser.reduce((acc, crr) => {
                return (acc as number) + (crr as number)
            })
        }

        const arrayScoreAdmin = dataSource.map((item) => item.scoreAdmin).filter((item) => typeof item === 'number')
        if (arrayScoreAdmin.length > 0) {
            totalScoreAdmin = arrayScoreAdmin.reduce((acc, crr) => {
                return (acc as number) + (crr as number)
            })
        }

        const percentScoreUser = (totalScoreUser * 100) / totalScoreFull
        const percentScoreAdmin = (totalScoreAdmin * 100) / totalScoreFull

        return (
            (dataSource.length &&
                ([
                    ...dataSource,
                    {
                        descriptionAdmin:
                            typeof percentScoreAdmin === 'number' && !isScoreAdminUndefined && !isScoreAdminNull
                                ? `คิดเป็น ${percentScoreAdmin.toFixed(2)}%`
                                : '-',
                        descriptionUser:
                            typeof percentScoreUser === 'number' && !isScoreUserUndefined && !isScoreUserNull
                                ? `คิดเป็น ${percentScoreUser.toFixed(2)}%`
                                : '-',
                        scoreFull:
                            isNumberScoreFull && (!isScoreAdminUndefined || !isScoreUserUndefined)
                                ? totalScoreFull
                                : '-',
                        id: dataSource.length + 1,
                        name: 'รวม',
                        scoreAdmin: !isScoreAdminUndefined && !isScoreAdminNull ? totalScoreAdmin : '-',
                        scoreUser: !isScoreUserUndefined && !isScoreUserNull ? totalScoreUser : '-',
                    },
                ] as TableDataSource[])) ||
            []
        )
    }, [dataSource])

    return { columns, dataSource: newDataSource }
}

type OverviewTableQuestionnaireFullReportViewProps = {
    dataSource?: TableDataSource[]
} & ReturnTypeUseOverviewTableQuestionnaireFullReport
const OverviewTableQuestionnaireFullReportView: React.FC<OverviewTableQuestionnaireFullReportViewProps> = ({
    columns,
    dataSource = [],
}) => {
    return (
        <StyledTablePreviewFullReport<TableDataSource>
            columns={columns}
            pagination={false}
            dataSource={dataSource}
            bordered
            rowKey='id'
            locale={{
                emptyText: <span>ไม่มีข้อมูล</span>,
            }}
            // summary={(pageData) => {
            //     let totalScoreFull = 0
            //     let totalUser = 0
            //     let totalAdmin = 0

            //     const isDisplayScoreAdmin = pageData.every((item) => item.scoreAdmin !== null)
            //     const isDisplayScoreUser = pageData.every((item) => item.scoreUser !== null)

            //     pageData.forEach(({ scoreFull, scoreUser, scoreAdmin }) => {
            //         totalScoreFull += scoreFull
            //         totalUser += scoreUser
            //         totalAdmin += scoreAdmin
            //     })

            //     return (
            //         <>
            //             <TableSummaryRow>
            //                 <TableSummaryCell>รวม</TableSummaryCell>
            //                 <TableSummaryCell>{totalScoreFull}</TableSummaryCell>
            //                 <TableSummaryCell>{isDisplayScoreUser ? totalUser.toFixed(2) : '-'}</TableSummaryCell>
            //                 <TableSummaryCell
            //                     css={{
            //                         backgroundColor: '#f5d01a !important',
            //                     }}
            //                 >
            //                     {isDisplayScoreUser
            //                         ? `คิดเป็น ${((totalUser * 100) / totalScoreFull).toFixed(2)}%`
            //                         : '-'}
            //                 </TableSummaryCell>
            //                 <TableSummaryCell>{isDisplayScoreAdmin ? totalAdmin.toFixed(2) : '-'}</TableSummaryCell>
            //                 <TableSummaryCell
            //                     css={{
            //                         backgroundColor: '#4472c4 !important',
            //                     }}
            //                 >
            //                     {isDisplayScoreAdmin
            //                         ? `คิดเป็น ${((totalAdmin * 100) / totalScoreFull).toFixed(2)}%`
            //                         : '-'}
            //                 </TableSummaryCell>
            //             </TableSummaryRow>
            //         </>
            //     )
            // }}
        />
    )
}

type OverviewTableQuestionnaireFullReportProps = {} & UseOverviewTableQuestionnaireFullReport &
    Omit<OverviewTableQuestionnaireFullReportViewProps, keyof ReturnTypeUseOverviewTableQuestionnaireFullReport>
const OverviewTableQuestionnaireFullReport: React.FC<OverviewTableQuestionnaireFullReportProps> = ({
    prefixLabel,
    titleCell,
    dataSource,
    ...props
}) => {
    const stateOverviewTableQuestionnaireFullReport = useOverviewTableQuestionnaireFullReport({
        prefixLabel,
        titleCell,
        dataSource,
    })
    return <OverviewTableQuestionnaireFullReportView {...stateOverviewTableQuestionnaireFullReport} {...props} />
}

export default OverviewTableQuestionnaireFullReport
